import {FC} from "react";

const CustomerIcon: FC<{color?: string; size?: number; style?: any}> = (props: any) => {
    return <svg
        style={{...props.style}}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={props.color ?? "inherit"}
    >
        <path
            d="M17 20.9998C15.3463 20.9983 13.7183 20.5896 12.26 19.8098L11.81 19.5598C8.70075 17.8881 6.15169 15.339 4.48 12.2298L4.23 11.7798C3.42982 10.3132 3.00713 8.67048 3 6.99978V6.32978C2.99958 5.79674 3.21196 5.28558 3.59 4.90978L5.28 3.21978C5.44413 3.05438 5.67581 2.97466 5.90696 3.00404C6.13811 3.03342 6.34248 3.16858 6.46 3.36978L8.71 7.22978C8.93753 7.62267 8.87183 8.11954 8.55 8.43978L6.66 10.3298C6.50304 10.485 6.46647 10.7248 6.57 10.9198L6.92 11.5798C8.17704 13.9082 10.0893 15.817 12.42 17.0698L13.08 17.4298C13.275 17.5333 13.5148 17.4967 13.67 17.3398L15.56 15.4498C15.8802 15.128 16.3771 15.0623 16.77 15.2898L20.63 17.5398C20.8312 17.6573 20.9664 17.8617 20.9957 18.0928C21.0251 18.324 20.9454 18.5557 20.78 18.7198L19.09 20.4098C18.7142 20.7878 18.203 21.0002 17.67 20.9998H17Z"
            fill={props.color ?? 'inherit'}
        />
    </svg>
}

export default CustomerIcon
